import React from 'react';
import { Button, Grid, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AddIcon from '@material-ui/icons/Add';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import { landingGearPositions } from '../';

const ComponentSerialsField = ({ value = [], error = [], onChange }) => {
  // Functional updates: Autocomplete can fire for several rows in the same tick.
  const updateRow = (index, key, fieldValue) => onChange(rows => rows.map((row, rowIndex) => rowIndex === index ? { ...row, [key]: fieldValue } : row));
  return (
    <div>
      <label className="for-label">Component Serial Number(s)</label>
      {value.map((row, index) => (
        <Grid container spacing={1} alignItems="center" key={index}>
          <Grid item xs={4}>
            {/* value and inputValue are both controlled so MUI's mount-time reset can't clear a saved label */}
            <Autocomplete
              id={`component-label-${index}`}
              freeSolo
              options={landingGearPositions}
              value={row.label || null}
              inputValue={row.label || ''}
              onChange={(e, label) => updateRow(index, 'label', label || '')}
              onInputChange={(e, label) => updateRow(index, 'label', label || '')}
              renderInput={params => <TextField {...params} label="Label" margin="dense" fullWidth InputLabelProps={{ shrink: true }} variant="outlined" />}
            />
          </Grid>
          <Grid item xs={7}>
            <TextField
              id={`component-serial-${index}`}
              label="Serial Number"
              margin="dense"
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={row.serial || ''}
              error={!!error[index]}
              helperText={error[index] || ''}
              onChange={(e) => updateRow(index, 'serial', e.target.value)}
            />
          </Grid>
          <Grid item xs={1}>
            <DeleteOutlinedIcon color="secondary" fontSize="small" style={{ cursor: 'pointer' }} onClick={() => onChange(rows => rows.filter((r, rowIndex) => rowIndex !== index))} />
          </Grid>
        </Grid>
      ))}
      <Button size="small" color="primary" onClick={() => onChange(rows => [...rows, { label: '', serial: '' }])}>
        <AddIcon fontSize="small" /> Add Component S/N
      </Button>
    </div>
  );
};
export default ComponentSerialsField;
